module.exports = __webpack_public_path__ + "static/media/22ESCWA9.ece1b513.jpg";